<template>
<div>
    <div class="flex flex-wrap">
        <div class="w-full md:w-3/4 md:pr-20">
            <h1 class="mb-5 font-sans text-n-gray-dark">My Resources</h1>
            <router-link class="button mb-12" to="/resources/create">Create New Resource</router-link>
            <div class="mb-8">
                <p class="mb-5">In this moment, we need to offer what we can. Add your existing services, products, art, workshops and educational offerings--along with the inspiring stories behind your work--for discovery on <a href="http://www.letsreimagine.org/resources" target="_blank">Reimagine Community Resources</a> and for inclusion on your Reimagine profile page. You can also create new text-based resources like articles or poems directly through this Portal. See the <a href="https://help.letsreimagine.org/hc/en-us/articles/360041714752-What-is-Reimagine-Community-Resources-" target="_blank">criteria for resource submissions</a> in our Help Center.</p>
            </div>
            <div class="flex flex-wrap -mx-6 pt-12">
                <user-dashboard-item
                    v-for="resource in resources"
                    :key="resource.id"
                    :resource="resource"></user-dashboard-item>
            </div>
        </div>
        <div class="w-full md:w-1/4 md:pt-40">
            <div class="sidebar-block border-t-5 border-black pt-3">
                <public-profile-link></public-profile-link>
                <h2 class="text-lg mb-5 font-sans text-n-gray-dark">Help with My Resources</h2>
                <ul class="list-reset mb-10 text-base">
                    <li class="mb-2"><a target="_blank" href="https://help.letsreimagine.org/hc/en-us/sections/360008462652-Submitting-your-community-resources">Creating &amp; Submitting Resources</a></li>
                </ul>

                <support></support>
            </div>
        </div>
    </div>
</div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import UserDashboardItem from './UserDashboardItem.vue'
    import Support from '../global/Support.vue'
    import PublicProfileLink from '../global/PublicProfileLink.vue'

    export default {
        name: 'ResourceUserDashboard',
        props: {},
        components:{
            UserDashboardItem,
            Support,
            PublicProfileLink
        },
        data: () => ({

        }),
        computed: {
            ...mapGetters({
                resources: 'resources',
            }),
        },
        watch: {},
        methods: {},
        mounted() {}
    }
</script>
